import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Inject,
  Page,
  Resize,
  Search,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import axios from "axios";
import { getCookie } from "cookies-next";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { Header, PageLoading } from "../../../components";
import { API_ROOT } from "../../../config";
import { useStateContext } from "../../../contexts/ContextProvider";
import "../../table.css";

const City = () => {
  const navigate = useNavigate();
  const { currentColor } = useStateContext();

  const abortController = new AbortController();

  const [pageLoading, setPageLoading] = useState(true);
  const [cityData, setCityData] = useState([]);
  const gridRef = useRef(null);

  const fetchData = async () => {
    await axios
      .get(API_ROOT + "/admin/city", {
        signal: abortController.signal,
        headers: {
          Authorization: getCookie("admin_auth"),
        },
      })
      .then((response) => {
        const cityList = response.data.data;

        setCityData(() =>
          cityList.map((item, index) => ({
            No: index + 1,
            NameProvince: item.province.name_province,
            NameCity: item.name_city,
            IsActive: item.is_active ? "Active" : "Inactive",
            MarkanyCityId: item.markany_city_id,
          }))
        );
      })
      .catch((error) => {
        if (error.code == "ERR_CANCELED") return;
        if (error.response) {
          if (error.response.status == 401) {
            navigate("/login");
          } else {
            toast.error("Failed to load city data");
          }
        } else {
          toast.error("Failed to load city data");
        }
      })
      .finally(() => setPageLoading(false));
  };

  useEffect(() => {
    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);

  const queryCellInfo = (args) => {
    args.cell?.classList.add("e-cell");
  };

  const dataBound = () => {
    if (gridRef.current) {
      gridRef.current.autoFitColumns([
        "No",
      //   "NameProvince",
      //   "NameCity",
        "IsActive",
        "MarkanyCityId",
      ]);
    }
  };

  const statusTemplate = (props) => {
    return (
      <span
        className={`px-2 py-1 rounded-full text-xs font-medium ${
          props.IsActive === "Active"
            ? "bg-green-100 text-green-800"
            : "bg-red-100 text-red-800"
        }`}
      >
        {props.IsActive}
      </span>
    );
  };

  return pageLoading ? (
    <PageLoading />
  ) : (
    <div className="m-2 md:m-10 mt-24 px-2 py-10 md:p-10 bg-white rounded-3xl">
      <Header title="City Data" />
      <div className="flex flex-col gap-4">
        <hr />
        <div className="overflow-x-auto">
          <div className="w-full">
            <GridComponent
              dataSource={cityData}
              width="auto"
              allowPaging
              allowSorting
              allowTextWrap={true}
              pageSettings={{
                pageCount: 5,
                pageSizes: ["All", "10", "25", "50"],
              }}
              textWrapSettings={{ wrapMode: "Content" }}
              toolbar={["Search"]}
              queryCellInfo={queryCellInfo}
              allowExcelExport={true}
              dataBound={dataBound}
              ref={gridRef}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="No"
                  headerText="No"
                  textAlign="Center"
                  width={50}
                />
                <ColumnDirective
                  field="NameProvince"
                  headerText="Province"
                  textAlign="Left"
                  minWidth={150}
                />
                <ColumnDirective
                  field="NameCity"
                  headerText="City"
                  textAlign="Left"
                  minWidth="150"
                />
                <ColumnDirective
                  field="IsActive"
                  headerText="Status"
                  textAlign="Center"
                  minWidth={100}
                  template={statusTemplate}
                />
                <ColumnDirective
                  field="MarkanyCityId"
                  headerText="Markany City ID"
                  textAlign="Center"
                  minWidth={150}
                />
              </ColumnsDirective>
              <Inject services={[Search, Toolbar, Page, Sort, Resize]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
};

export default City;
